import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';

import Header from './Main/Header';
import Content from './Main/Content';
import Layout from './Main/Layout';
import { tabRoutes } from '../routes';


class RootModule extends Component {
  render() {
    return (
      <Layout>
        <Header />
        <Switch>
          <Route path={tabRoutes.default} component={Content} />
          <Redirect to={tabRoutes.sections} />
        </Switch>
      </Layout>
    );
  }
}


export default RootModule;



// WEBPACK FOOTER //
// ./src/Root/RootModule.js